// core
import React from "react";
import cx from "classnames";

// interfaces
interface IQuoteTableCellProps {
    isHighlighted?: boolean;
    isFirstSection?: boolean;
    isLastSection?: boolean;
    isSelected?: boolean;
    hasBlockingError?: boolean;
    renderOnError?: boolean;
    className?: string;
    children: React.ReactNode;
}

// rendering
const QuoteTableCell: React.FC<IQuoteTableCellProps> = (props) => {
    const {
        isHighlighted,
        isFirstSection,
        isLastSection,
        isSelected,
        hasBlockingError,
        renderOnError,
        className,
        children
    } = props;

    const renderEmptyPlaceholder = !renderOnError && hasBlockingError;

    return (
        <div
            className={cx([
                "layout-quote-table-cell",
                {
                    ["panel-side-border-gold"]: isHighlighted,
                    ["panel-side-border"]: !isHighlighted,
                    ["panel-side-first-section"]: isFirstSection,
                    ["panel-side-last-section"]: isLastSection,
                    ["panel-quote-selected"]: isSelected,
                    ["panel-quote-disabled"]: hasBlockingError,
                    ["layout-flex-row--centered"]: renderEmptyPlaceholder,
                    [className]: !!className
                }
            ])}>
            {/* If we have an error state, we only render content for non-error sections */}
            {renderEmptyPlaceholder ? (
                <span className={cx("width-full text-align--center")}>-</span>
            ) : (
                children
            )}
        </div>
    );
};

export default React.memo(QuoteTableCell);
